import { buildAudienceSelectionAdjustment } from "../../hooks/helpers/sbPlacementModifier.helper"
import { ISbBidAdjustmentItem } from "../../types/sbPlacementApi.types"
import {
  SponsoredBrandsPlacementsAction,
  SponsoredBrandsPlacementsActionType,
  SponsoredBrandsPlacementsState,
} from "../types/sbPlacements"

const initialState: SponsoredBrandsPlacementsState = {
  placementData: [],
  pendingAdjustments: {},
  loading: false,
  error: null,
}

export const sponsoredBrandsPlacementsReducer = (
  state = initialState,
  action: SponsoredBrandsPlacementsAction
): SponsoredBrandsPlacementsState => {
  switch (action.type) {
    case SponsoredBrandsPlacementsActionType.FETCH_SPONSORED_BRANDS_PLACEMENTS:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case SponsoredBrandsPlacementsActionType.FETCH_SPONSORED_BRANDS_PLACEMENTS_SUCCESS:
      return {
        ...state,
        placementData: mergeByCampaignId(state.placementData, action.payload),
        loading: false,
        error: null,
      }
    case SponsoredBrandsPlacementsActionType.FETCH_SPONSORED_BRANDS_PLACEMENTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case SponsoredBrandsPlacementsActionType.SET_SB_PLACEMENT_ADJUSTMENT:
      return {
        ...state,
        pendingAdjustments: applyAdjustment(
          state.pendingAdjustments,
          action.payload.campaignId,
          action.payload.adjustment
        ),
      }
    case SponsoredBrandsPlacementsActionType.CLEAR_SB_PLACEMENT_ADJUSTMENTS:
      return {
        ...state,
        pendingAdjustments: {},
      }
    case SponsoredBrandsPlacementsActionType.APPLY_SB_AUDIENCE_TO_CAMPAIGNS:
      return {
        ...state,
        pendingAdjustments: applyAudienceSelection(
          state.pendingAdjustments,
          action.payload.campaignIds,
          action.payload.audienceId
        ),
      }
    case SponsoredBrandsPlacementsActionType.RESET_SPONSORED_BRANDS_PLACEMENTS:
      return initialState
    default:
      return state
  }
}

function applyAdjustment<T>(
  current: Record<string, T>,
  campaignId: string,
  adjustment: T | null
): Record<string, T> {
  const next = { ...current }
  if (adjustment === null) {
    delete next[campaignId]
  } else {
    next[campaignId] = adjustment
  }
  return next
}

function applyAudienceSelection(
  current: Record<string, ISbBidAdjustmentItem>,
  campaignIds: string[],
  audienceId: string
): Record<string, ISbBidAdjustmentItem> {
  const next = { ...current }
  for (const campaignId of campaignIds) {
    next[campaignId] = buildAudienceSelectionAdjustment(campaignId, current[campaignId], audienceId)
  }
  return next
}

function mergeByCampaignId<T extends { campaignId: string }>(current: T[], incoming: T[]): T[] {
  const incomingIds = incoming.map((item) => item.campaignId)
  return [...current.filter((item) => !incomingIds.includes(item.campaignId)), ...incoming]
}
